import React from 'react'
import {useIntl} from 'react-intl'
import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
// TODO: refactor — legacy `optimizely/assets/recommendationsCarousel` removed in GDI cleanup, awaiting PDP/PLP refactor
const RecommendationsCarousel = () => null
import {useBrand} from '../../../contexts/brand-context'

const LowResultsCarousel = () => {
    const intl = useIntl()
    const {isGarage} = useBrand()
    const styles = useMultiStyleConfig('PlpSrpPages')

    return (
        <Box data-testid="sf-product-low-results-carousel" {...styles.lowResultsContainer}>
            <RecommendationsCarousel
                Title={intl.formatMessage(
                    isGarage
                        ? {
                              id: 'empty_search_results.carousel.title_garage',
                              defaultMessage: "WE THINK YOU'LL LOVE..."
                          }
                        : {
                              id: 'empty_search_results.carousel.title_dynamite',
                              defaultMessage: "We think you'll love these..."
                          }
                )}
                TitleStyle={styles.emptySearchCarouselTitle}
                slidesToShowDesktop={6.5}
                AIModel="recommendations"
                carouselID="low-results-recommendations"
            />
        </Box>
    )
}

export default LowResultsCarousel
